import type { CityConfig } from "../city-template/types";

export const independenceMOConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Independence",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "independence-mo",
  route: "/cities/independence-mo",
  title: "Emergency Passport Independence, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Independence, MO — as fast as 24 hours. Serving Jackson County and the Kansas City metro. A+ BBB rated registered State Dept. courier serving Truman's hometown and eastern Jackson County. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Independence, MO",
  heroSubtitle: "Kansas City business trip to Frankfurt with ten days notice? Truman Library conference and your passport is expired? Family cruise out of Miami and the kids need first passports? We help Independence residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Independence%20Missouri%20historic%20downtown%20square%20with%20the%20old%20Jackson%20County%20Courthouse%20and%20Harry%20Truman%20statue%20at%20golden%20hour%20wide%20angle%20shot%20showing%20the%20charming%20midwestern%20town%20architecture%20tree-lined%20streets%20and%20blue%20sky%20with%20soft%20clouds%20professional%20drone%20photography%20warm%20tones&width=1800&height=700&seq=independence-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Independence Missouri historic downtown square with Jackson County Courthouse and Truman statue at golden hour",
  geoPosition: "39.0911;-94.4155",
  geoPlacename: "Independence, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 500 miles northeast of Independence via I-70/I-55",
  },
  nearbyCitiesZips: [
    { name: "Independence", zips: "64050, 64052, 64055, 64056, 64057, 64058" },
    { name: "Blue Springs", zips: "64013, 64014, 64015" },
    { name: "Lee's Summit", zips: "64063, 64064, 64081, 64086" },
    { name: "Raytown", zips: "64133, 64138" },
    { name: "Grain Valley", zips: "64029" },
    { name: "Sugar Creek", zips: "64054, 64056" },
    { name: "Oak Grove", zips: "64075" },
    { name: "Buckner", zips: "64016" },
    { name: "Liberty", zips: "64068, 64069" },
    { name: "Gladstone", zips: "64118, 64119" },
    { name: "Kansas City", zips: "64101–64199" },
    { name: "Overland Park", zips: "66204–66225" },
    { name: "Olathe", zips: "66051–66063" },
    { name: "Grandview", zips: "64030" },
    { name: "Belton", zips: "64012" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Kansas City metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Jackson County Hub", desc: "Serving Independence, Blue Springs, Raytown, and eastern KC metro" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Fast passport renewal in Lee's Summit, MO", route: "/cities/lees-summit" },
    { name: "Emergency passport help in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Urgent passport services in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Des Moines, IA", route: "/cities/des-moines" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Independence remotely via secure courier. We do not have a walk-in office in Independence — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Jackson County and the Kansas City metro.",
  fpcOfficeAddress: "1200 Main St, Kansas City, MO 64105",
  mapEmbedUrl: "https://www.google.com/maps?q=1200+Main+St,+Kansas+City,+MO+64105&output=embed",
  fpcOfficeDistance: "Serving all of eastern Jackson County and the KC metro including Blue Springs, Raytown, Grain Valley, and Oak Grove",
  serviceAreaIntro: "From the historic Independence Square and Truman Library to the growing communities of Blue Springs and Grain Valley, from the suburban neighborhoods of Lee's Summit to the industrial corridor along I-70, from the shopping districts of Raytown to the quiet streets of Sugar Creek — Fast Passport Center serves the entire eastern Jackson County and Kansas City metro area. We regularly help travelers from Independence, Blue Springs, and surrounding communities get their passports fast without the 8-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Independence neighborhoods and the surrounding eastern Jackson County area including Blue Springs, Lee's Summit, Raytown, Grain Valley, Sugar Creek, Oak Grove, Buckner, and Liberty. If you are anywhere in Jackson County or the eastern Kansas City metro, we have you covered.",
  howItWorksIntro: "Most Independence travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Independence travelers often face an 8-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Independence and Jackson County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Independence? Here are the most common ones we hear from Jackson County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/motor-vehicle/",
  dmvLabel: "Missouri DOR — Motor Vehicle & Driver Licensing",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Independence travelers with immediate departure needs — as fast as 24 hours for urgent international flights from MCI.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Independence, MO",
      rating: 5,
      text: "Business trip to London came up with 4 days notice. My passport was buried somewhere in my office. Fast Passport Center got my renewal in 28 hours. I made the flight. Truman would approve!",
      service: "Passport Renewal",
    },
    {
      name: "Debra L.",
      location: "Blue Springs, MO",
      rating: 5,
      text: "Daughter's wedding in Mexico and I realized my passport expired two weeks before. Fast Passport Center handled everything. Got it in 3 days. I was dancing at the reception stress-free!",
      service: "Passport Renewal",
    },
    {
      name: "James K.",
      location: "Raytown, MO",
      rating: 5,
      text: "Both kids needed first passports for spring break in Cancun. Fast Passport Center walked us through the child passport process. Got them in 5 days. Amazing service for Jackson County families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "independence-mo-1",
      name: "Independence Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 N Lynn St",
      city: "Independence",
      state: "MO",
      zip: "64050",
      phone: "(816) 254-9842",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Independence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Independence facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "independence-mo-2",
      name: "Jackson County Clerk — Independence",
      type: "County Clerk Passport Acceptance",
      address: "308 W Kansas Ave, 2nd Floor",
      city: "Independence",
      state: "MO",
      zip: "64050",
      phone: "(816) 881-4343",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Historic Independence Square",
      website: "https://www.jacksongov.org/Government/County-Clerk",
      websiteLabel: "Jackson County Clerk",
      notes: "Accepts passport applications at the Historic Truman Courthouse. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "independence-mo-3",
      name: "Blue Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 NW 11th St",
      city: "Blue Springs",
      state: "MO",
      zip: "64015",
      phone: "(816) 229-0204",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles east of Independence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Blue Springs and eastern Jackson County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "independence-mo-4",
      name: "Lee's Summit Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 SE Green St",
      city: "Lee's Summit",
      state: "MO",
      zip: "64063",
      phone: "(816) 524-3792",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Independence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lee's Summit and southern Jackson County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "independence-mo-5",
      name: "Raytown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10100 E 63rd St",
      city: "Raytown",
      state: "MO",
      zip: "64133",
      phone: "(816) 353-8119",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles west of Independence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Raytown and western Independence area. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Independence photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Jackson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Independence applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Jackson County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Independence travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Independence." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Independence address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Independence before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Independence for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Independence?", a: "Fast Passport Center offers fast passport renewal in Independence in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Independence?", a: "The nearest regional passport agency to Independence is the Chicago Passport Agency, approximately 500 miles northeast via I-70/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Independence without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Independence?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 8 hours from Independence — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Jackson County and KC metro residents." },
    { q: "Do you serve the entire eastern Jackson County region?", a: "Absolutely. Fast Passport Center serves the entire eastern Jackson County and Kansas City metro region including Independence, Blue Springs, Lee's Summit, Raytown, Grain Valley, and surrounding areas. Our courier service works seamlessly from any address in Jackson County." },
    { q: "Can I expedite a child passport in Independence?", a: "Yes. Fast Passport Center expedites child passports in Independence for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Jackson County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Independence with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Independence", address: "3411 S Noland Rd, Independence, MO 64055", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Independence", address: "16801 E US Hwy 24, Independence, MO 64056", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Blue Springs", address: "1500 NW State Route 7, Blue Springs, MO 64014", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "Walmart Supercenter — Blue Springs", address: "600 NE Coronado Dr, Blue Springs, MO 64014", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Independence",
      address: "17801 E US Hwy 40, Independence, MO 64055",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Lee's Summit",
      address: "630 NW McNary Ct, Lee's Summit, MO 64086",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lee's Summit and southern Jackson County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Kansas City (Blue Ridge)",
      address: "11515 Blue Ridge Blvd, Kansas City, MO 64134",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves South KC and Grandview areas. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "35 miles northwest of Independence",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with direct flights worldwide. About 40 minutes from Independence via I-435.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "MKC",
      name: "Charles B. Wheeler Downtown Airport",
      distance: "15 miles west of Independence",
      address: "900 NW Richards Rd, Kansas City, MO 64116",
      note: "General aviation and regional flights. About 25 minutes from Independence.",
      flightUrl: "https://www.flymkc.com/",
      flightLabel: "MKC Airport",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "240 miles east of Independence",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international hub. About 3 hours 45 minutes from Independence via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
  ],
};